import {
  MESSAGE_LOADING,
  MESSAGE_ADD,
  MESSAGE_UPDATE,
  MESSAGE_DELETE,
  MESSAGE_FILTERS,
  MESSAGE_LIST,
} from "actions/message/types";

const initialState = {
  loading: false,
  filters: {},
  list: {
    content: []
  }
};

export default function (state = initialState, action) {
  switch (action.type) {
    case MESSAGE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case MESSAGE_ADD:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          content: state.list.content.concat(action.payload)
        }
      };
    case MESSAGE_UPDATE:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          content: state.list.content
            .splice(state.list.content.findIndex(item => item.id === action.payload.id), 1, action.payload)
        },
      };
    case MESSAGE_DELETE:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          content: state.list.content.filter(i => i.id !== action.payload.id)
        },
      };
    case MESSAGE_FILTERS:
      return {
        ...state,
        loading: false,
        filters: action.payload
      };
    case MESSAGE_LIST:
      return {
        ...state,
        loading: false,
        list: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/messageReducer.js